/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthPlatformRemotePatient } from './PalAuthPlatformRemotePatient';
import {
    PalAuthPlatformRemotePatientFromJSON,
    PalAuthPlatformRemotePatientFromJSONTyped,
    PalAuthPlatformRemotePatientToJSON,
    PalAuthPlatformRemotePatientToJSONTyped,
} from './PalAuthPlatformRemotePatient';

/**
 * 
 * @export
 * @interface SearchPalAuthPlatformRemotePatient200Response
 */
export interface SearchPalAuthPlatformRemotePatient200Response {
    /**
     * 
     */
    data?: Array<PalAuthPlatformRemotePatient>;
}

/**
 * Check if a given object implements the SearchPalAuthPlatformRemotePatient200Response interface.
 */
export function instanceOfSearchPalAuthPlatformRemotePatient200Response(value: object): value is SearchPalAuthPlatformRemotePatient200Response {
    return true;
}

export function SearchPalAuthPlatformRemotePatient200ResponseFromJSON(json: any): SearchPalAuthPlatformRemotePatient200Response {
    return SearchPalAuthPlatformRemotePatient200ResponseFromJSONTyped(json, false);
}

export function SearchPalAuthPlatformRemotePatient200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPalAuthPlatformRemotePatient200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PalAuthPlatformRemotePatientFromJSON)),
    };
}

export function SearchPalAuthPlatformRemotePatient200ResponseToJSON(json: any): SearchPalAuthPlatformRemotePatient200Response {
    return SearchPalAuthPlatformRemotePatient200ResponseToJSONTyped(json, false);
}

export function SearchPalAuthPlatformRemotePatient200ResponseToJSONTyped(value?: SearchPalAuthPlatformRemotePatient200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PalAuthPlatformRemotePatientToJSON)),
    };
}

